// extracted by mini-css-extract-plugin
export default {"header":"style_header__RxAj7","desktop-nav":"style_desktop-nav__MYxAe","mob-nav":"style_mob-nav__zzQS9","logo-css":"style_logo-css__xMoGr"};